<template>
<div>
  <div class="modal fade" data-backdrop="static" id="modal-add-company">
        <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title">{{$t('customer.title_add_new_compnay')}}</h1>
              </div>
              <div class="modal-body">
                <b-form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Company name -->
                      <label for="first_name" class="control-label">{{$t('customer.firstname')}} <span style="color:red;">*</span></label>
                        <div class="form-group">
                          <div>
                            <b-form-input
                              required
                              :placeholder="$t('customer.firstname')"
                              class = "form-control"
                              v-model="company.name"
                            />
                          </div>
                        </div>

                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Companay Tax Code -->
                      <label for="first_name" class="control-label">{{$t('customer.company_tax_code')}} <span style="color:red;">*</span></label>
                        <div class="form-group">
                          <div>
                            <b-form-input
                              required
                              :placeholder="$t('customer.company_tax_code')"
                              class = "form-control"
                              v-model="company.tax_code"
                            />
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- Address -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('customer.company_address')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('customer.company_address')"
                              class = "form-control"
                              v-model="company.address"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- legal_representation -->
                      <b-form-group label-size="sm" label-for="input-sm"  :label="$t('customer.legal_representation')">
                        <div class="form-group">
                          <div>
                            <input
                              :placeholder="$t('customer.legal_representation')"
                              class = "form-control"
                              v-model="company.representative_name"
                            >
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- company_phone -->
                      <label for="first_name" class="control-label">{{$t('customer.company_phone')}} <span style="color:red;">*</span></label>
                        <div class="form-group">
                          <div>
                            <b-form-input
                              required
                              :placeholder="$t('customer.company_phone')"
                              class = "form-control"
                              v-model="company.phone"
                            />
                          </div>
                        </div>

                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                      <!-- company_email -->
                      <label for="first_name" class="control-label">{{$t('customer.company_email')}} <span style="color:red;">*</span></label>
                        <div class="form-group">
                          <div>
                            <b-form-input
                              required
                              :placeholder="$t('customer.company_email')"
                              class = "form-control"
                              v-model="company.email"
                            />
                          </div>
                        </div>
                    </div>
                  </div>
                  <b-button
                      ref="formsubmitbutton"
                      type="submit"
                      variant="primary"
                      style="display: none;"
                    >{{$t('common.submit')}}</b-button>
                </b-form>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  @click="onSave()"
                  :class="'btn btn-primary btn-sm pull-right'"
                >{{$t('common.save')}}</button>
                <button
                  type="button"
                  class='btn btn-warning btn-sm pull-left'
                  @click="closeModal"
                >{{$t('common.back')}}</button>
              </div>
            </div>
        </div>
    </div>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils'

export default {
  name: 'lte-modal',
  data() {
    return {
        company:{
          "name": "",
          "tax_code": "",
          "address": "",
          "representative_name": "",
          "phone": "",
          "email": ""
        },
        customer_company_id: 0
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    showModalAddCompany(customer_company_id) {
      if (!utils.isNull(customer_company_id) != 0) {
        this.customer_company_id = customer_company_id
        this.GET_DETAIL_LEASEBACK_COMPANY({id: customer_company_id}).then(
          function(res) {
            let data = res.data
            this.company.name = data.name
            this.company.tax_code = data.tax_code
            this.company.address = data.address
            this.company.representative_name = data.representative_name
            this.company.phone = data.phone
            this.company.email = data.email
          }.bind(this)
        )
      } else {
        this.customer_company_id = 0
        this.company.name = ''
        this.company.tax_code = ''
        this.company.address = ''
        this.company.representative_name = ''
        this.company.phone = ''
        this.company.email = ''
      }
      $("#modal-add-company").modal("show");
    },
    onSubmit: function(status_booking) {
      let leaseback_company = {
        "date_deleted": null,
        "name": this.company.name,
        "tax_code": this.company.tax_code,
        "address":this.company.address,
        "representative_name": this.company.representative_name,
        "phone": this.company.phone,
        "email": this.company.email
      }
      if (this.customer_company_id != 0) {
        this.UPDATE_LEASEBACK_COMPANY({id: this.customer_company_id, ...leaseback_company}).then(
          function (res) {
            this.$emit("reload_leaseback_company")
            this.ON_SHOW_TOAST({
                message: this.$t('customer.update_leaseback_company_successfully'),
                styleType: "success"
            });
          }.bind(this)
        ).catch(
          function (error) {
            let error_code = error.response.data.error_code
            if (error_code == "tax_code_is_already") {
              this.ON_SHOW_TOAST({
                message: 'Mã số thuế doanh nghiệp đã tồn tại',
                styleType: "danger"
              })
            } else {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              })
            }
          }.bind(this)
        );
      } else {
        this.ADD_LEASEBACK_COMPANY(leaseback_company).then(
          function (res) {
            this.$emit("reload_leaseback_company")
            this.ON_SHOW_TOAST({
                message: this.$t('customer.add_leaseback_company_successfully'),
                styleType: "success"
            });
          }.bind(this)
        ).catch(
          function (error) {
            let error_code = error.response.data.error_code
            if (error_code == "tax_code_is_already") {
              this.ON_SHOW_TOAST({
                message: 'Mã số thuế doanh nghiệp đã tồn tại',
                styleType: "danger"
              })
            } else {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              })
            }
          }.bind(this)
        );
      }
      $("#modal-add-company").modal("hide");
    },
    closeModal: function() {
        $("#modal-add-company").modal("hide");
        this.disabledCheckin = true
    },
    onSave() {
      this.$refs.formsubmitbutton.click();
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "ADD_LEASEBACK_COMPANY",
      "GET_DETAIL_LEASEBACK_COMPANY",
      "UPDATE_LEASEBACK_COMPANY"
    ])
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert
  },
}
</script>
<style lang="scss" scoped>
    .mg-left {
        margin-left: 5px;
    }
    .hide-scroll-bar::-webkit-scrollbar {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/LTEModalApartmentLeasebackCompany.vue